export default __webpack_public_path__ + "static/media/Coruscant Ward of Maahes.d0d2e239.jpg";